import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { assetWithdraw } from "store/actions";
import toastr from "toastr";
import { useDispatch, useSelector } from "react-redux";
import Loader from "Component/Common/Loader";
import transakImg from '../../../assets/images/transak.jpeg'
import { useTranslation } from 'react-i18next';
import ScrollLockModal from "Component/Common/ScrollLock-Model";

export default function ViewMoreModel(props) {
    const { t } = useTranslation();

  /**
     * Used for render the UI of view more 
     */
    return (
        <ScrollLockModal
            {...props}

            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="buy_modal Tranferconfirm-modal"
        >


            <div className="modal_inner_main position-relative">
                <a
                    href="javascript:void(0)"
                    onClick={() => {
                        props.onHide();

                    }}
                    className="close-btn"
                >
                    <img src="/images/close_img.png" alt="" className="img-fluid" />
                </a>


                <div className="modal_buy-cont">

                    <div className="details_box_innermod text-start">


                        <div className="from_to_wrap d-flex align-item-center justify-content-between">
                            <div className="from_wrap">
                                <h5 className="text-start">{t('from')}</h5>

                                <div className="address_show d-flex align-item-center">
                                    <div className="address_img">
                                        <img src={transakImg} className="img-fluid" />
                                    </div>
                                    <p className="text-truncate w-50">{props?.selectedItem?.sourceAddress}</p>
                                </div>
                            </div>
                            <div className="from_to">
                                <h5 className="text-end">{t('to')}</h5>

                                <div className="address_show d-flex align-item-center">
                                    <div className="address_img">
                                        <img src={transakImg} className="img-fluid" />
                                    </div>
                                    <p className="text-truncate w-50">{props?.selectedItem?.destinationAddress}</p>
                                </div>
                            </div>
                        </div>

                        <ul className="p-0 m-0 details_list mt-2">
                            <li>
                                <p>{t('requested_amt')}</p>
                                <p>
                                    <strong>{props?.selectedItem?.amountInfo?.requestedAmount}</strong>
                                </p>
                            </li>
                            {
                                props?.selectedItem?.feeInfo?.gasPrice &&
                                <li>
                                    <p>{t('gas_price')}</p>
                                    <p>
                                        <strong>{props?.selectedItem?.feeInfo?.gasPrice}</strong>
                                    </p>
                                </li>
                            }

                            <li>
                                <p>{t('operation')}</p>
                                <p>
                                    <strong>{props?.selectedItem?.operation}</strong>
                                </p>
                            </li>


                            <li>
                                <p>{t('status')}</p>
                                <p>
                                    <strong>{`${props?.selectedItem?.status && props?.selectedItem?.status} - ${props?.selectedItem?.subStatus && props?.selectedItem?.subStatus}`}</strong>
                                </p>
                            </li>


                        </ul>
                    </div>


                    <div className="modal_buy_btn d-flex justify-content-center gap-3 mt-2">
                        <Button
                            className="mod_cancelbtn copy_btn"
                            onClick={() => {
                                props.onHide();

                            }}
                        >
                            {t('close')}
                        </Button>

                    </div>
                </div>
            </div>
        </ScrollLockModal>
    );
}
